import ReactMounter from 'lib/ReactMounter';
import ContactFormPage from 'pages/ContactFormPage/ContactFormPage';

ReactMounter.registerComponentToMountOnLoad('ContactFormPage', ContactFormPage);
